import { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import useGotchiQuests from 'state/vvsgotchi/hooks/useGotchiQuests'
import { QuestCategory } from 'state/vvsgotchi/models'

import QuestsList from 'views/VvsGotchi/components/QuestsList'

import { StyledQuestDetailFlex } from './styles'
import { SubNav } from './SubNav'
import Category from './Category'

const QuestsIndexSection = () => {
  const history = useHistory<{ focus?: string }>()
  const [category, setCategory] = useState<Exclude<QuestCategory, QuestCategory.ONBOARDING>>(QuestCategory.DAILY_WORK)
  const { owner } = useGotchiOwner()
  const { findQuests } = useGotchiQuests()
  const quests = findQuests((q) => q.category === category)

  const questsFlexRef = useRef<HTMLDivElement>()

  useEffect(() => {
    if (history.location.state?.focus === 'quests' && questsFlexRef.current) {
      setTimeout(() => {
        questsFlexRef.current.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    }

    return null
  }, [history.location.state?.focus])

  return (
    <StyledQuestDetailFlex ref={questsFlexRef}>
      <SubNav category={category} setCategory={setCategory} />

      <Category category={category}>
        <QuestsList category={category} quests={quests} owner={owner} />
      </Category>
    </StyledQuestDetailFlex>
  )
}

export default QuestsIndexSection
